import { render, staticRenderFns } from "./AudioController.vue?vue&type=template&id=78035910&scoped=true&"
import script from "./AudioController.vue?vue&type=script&lang=js&"
export * from "./AudioController.vue?vue&type=script&lang=js&"
import style0 from "./AudioController.vue?vue&type=style&index=0&id=78035910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78035910",
  null
  
)

export default component.exports